import moment from "moment/moment";
import { map, pipe } from "../../../utilities/fp";

export function prepareEvents(events = []) {
  var filterInvalidBreakTimes = (events = []) =>
    events.filter(
      (e) =>
        !(e.appointmentType === "break_time" && moment(e.start).isSame(e.end)),
    );

  var isNotAvailabilityTime = (x) => !x.availabilityGrid;
  var isAvailabilityTime = (x) => x.availabilityGrid;

  var groupByResource = (events = []) =>
    Object.values(
      events.reduce((acc, event) => {
        if (!acc[event.resourceId]) {
          return {
            ...acc,
            [event.resourceId]: [event],
          };
        } else {
          return {
            ...acc,
            [event.resourceId]: [...acc[event.resourceId], event],
          };
        }
      }, {}),
    );

  var groupIntersected = (events = []) => {
    var withoutAvailabilityTime = events.filter(isNotAvailabilityTime);
    var availabilityTimes = events.filter(isAvailabilityTime);

    withoutAvailabilityTime.sort(
      (x, y) => new Date(x.start) - new Date(y.start),
    );

    var groupedEvents = [availabilityTimes];
    var group = [];
    var lastEvent = null;

    withoutAvailabilityTime.forEach((event) => {
      if (lastEvent && new Date(lastEvent.end) > new Date(event.start)) {
        group.push(event);
      } else {
        if (group.length) {
          groupedEvents.push(group);
        }
        group = [event];
      }

      lastEvent = event;
    });

    if (group.length) {
      groupedEvents.push(group);
    }

    return groupedEvents;
  };

  var correctZIndexesForGroups =
    (baseZIndex) =>
    (groupedEvents = []) => {
      return groupedEvents.map((group) => {
        const withoutAvailabilityTimes = group.filter(isNotAvailabilityTime);
        const availabilityTimes = group.filter(isAvailabilityTime);

        withoutAvailabilityTimes.sort(
          (x, y) => new Date(y.start).getTime() - new Date(x.start).getTime(),
        );

        return [
          ...withoutAvailabilityTimes.map((event) => ({
            ...event,
            zIndex: baseZIndex,
          })),
          ...availabilityTimes,
        ];
      });
    };

  var sortEventsByStartAndIndex = (events = []) => {
    const withoutBreakTime = events.filter(
      (x) => x.appointmentType !== "break_time",
    );

    const withBreakTime = events.filter(
      (x) => x.appointmentType === "break_time",
    );

    withoutBreakTime.sort(
      (a, b) => moment(b.end).diff(b.start) - moment(a.end).diff(a.start),
    );

    return [...withoutBreakTime, ...withBreakTime].map((event, index) => ({
      ...event,
      zIndex: index + 1,
    }));
  };

  return pipe(
    events,
    filterInvalidBreakTimes,
    groupByResource,
    map(groupIntersected),
    map(correctZIndexesForGroups(3)),
    (x) => x.flat().flat(),
    sortEventsByStartAndIndex,
  );
}

export const isAdditionalProviderAppointment = (details = {}) => {
  return details.appointment_type === "virtual" && !details.is_main_provider;
};

export const apiDateFormat = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

export const showSelectedWeek = (date = moment()) => {
  let showSelectedLabel = "";
  let startOfWeek = moment(date).startOf("week");
  let ednOfWeek = moment(date).endOf("week");
  if (startOfWeek.format("YYYY") != ednOfWeek.format("YYYY")) {
    showSelectedLabel =
      startOfWeek.format("MMM Do, YY - ") + ednOfWeek.format("MMM Do, YY");
  } else if (startOfWeek.format("MM") != ednOfWeek.format("MM")) {
    showSelectedLabel =
      startOfWeek.format("MMM Do - ") + ednOfWeek.format("MMM Do, YYYY");
  } else {
    showSelectedLabel =
      startOfWeek.format("MMM ") +
      startOfWeek.format("Do - ") +
      ednOfWeek.format("Do, YYYY");
  }
  return showSelectedLabel;
};

export const makeTitle = (obj) => {
  let titleArr = [],
    title = "";
  if (obj.appointment_services) {
    obj.appointment_services.map((objInner) => {
      if (objInner.service) {
        titleArr.push(objInner.service.name);
      }
    });
  }
  if (titleArr.length) {
    title = titleArr.join(", ");
  }
  return title;
};

export const startEndDateOfWeek = (date, format = "MM-DD-YYYY") => {
  return {
    start: moment(date, format).startOf("week"),
    end: moment(date, format).endOf("week"),
  };
};

export const viewDateFormat = (date) => {
  return moment(date).format("MMMM DD, YYYY");
};
